<template>
  <footer class="golomt-footer">
    <div class="container pd-t-50 pd-b-30">
      <div class="row">
        <!-- Branch Organizations Section -->
        <div class="col-md-5">
          <h5 class="text-white mb-3">Мэргэжлийн холбоод</h5>
          <div class="footer-links">
            <div class=" text-white mb-2">
              <i class="fa fa-map-marker mr-2"></i>МОНГОЛЫН ГАЗАР ЗОХИОН БАЙГУУЛАЛТЫН ХОЛБОО НҮТББ
            </div>
            <div class=" text-white mb-2">
              <i class="fa fa-map-marker mr-2"></i>МОНГОЛЫН ГЕОДЕЗИ, ФОТОГРАММЕТР, ЗУРАГ ЗҮЙН ХОЛБОО НҮТББ
            </div>
            <div class=" text-white mb-2">
              <i class="fa fa-map-marker mr-2"></i>МОНГОЛЫН ГАЗРЫН МЕНЕЖМЕНТИЙН НЭГДСЭН ЭВСЭЛ НҮТББ
            </div>
            <div class=" text-white mb-2">
              <i class="fa fa-map-marker mr-2"></i>МОНГОЛЫН КАДАСТРЫН ХОЛБОО НҮТББ
            </div>
          </div>
        </div>

        <!-- Common Links Section -->
        <div class="col-md-2">
          <h5 class="text-white mb-3">Нийтлэг холбоосууд</h5>
          <div class="footer-links">
            <router-link v-for="page in pages" :key="page.id" class="nav-link text-white p-0 mb-2"
              :to="{
                  name: $store.state.app.activeGroup.publicPage.route,
                  params: { id: page.id, cid: 0 }
                }"
              >
              {{ page.task }}
            </router-link>
          </div>
        </div>

        <!-- Transparency Section -->
        <div class="col-md-2">
          <h5 class="text-white mb-3">Ил тод</h5>
          <div class="footer-links">
            <a href="https://gazar.gov.mn/intro/transparency/legal-framework" target="_blank" class="nav-link text-white p-0 mb-2">Хууль эрхзүй</a>
            <a href="https://gazar.gov.mn/intro/transparency/human-resource" target="_blank" class="nav-link text-white p-0 mb-2">Хүнийй нөөц</a>
            <a href="https://gazar.gov.mn/intro/transparency/tender" target="_blank" class="nav-link text-white p-0 mb-2">Тендер</a>
            <a href="https://shilendans.gov.mn/organization/4805" target="_blank" class="nav-link text-white p-0 mb-2">Шилэн данс</a>
          </div>
        </div>

        <!-- Contact Information Section -->
        <div class="col-md-3">
          <h5 class="text-white mb-3">ХОЛБОО БАРИХ</h5>
          <div class="contact-info">
            <div class="contact-item mb-3">
              <i class="fa fa-home text-white mr-2"></i>
              <span class="text-white">
                Засгийн газрын талбай, 4-р хороо,<br>
                Чингэлтэй дүүрэг, Улаанбаатар хот
              </span>
            </div>
            
            <div class="contact-item mb-2">
              <i class="fa fa-print text-white mr-2"></i>
              <span class="text-white">Шуудангийн хаяг: 15170</span>
            </div>
            
            <div class="contact-item mb-2">
              <i class="fa fa-envelope text-white mr-2"></i>
              <a href="mailto:info@gazar.gov.mn" class="text-white">info@gazar.gov.mn</a>
            </div>
            
            <div class="contact-item mb-2">
              <i class="fa fa-phone text-white mr-2"></i>
              <a href="tel:18000101" class="text-white">1800 0101</a>
            </div>
            
            <div class="contact-item mb-2">
              <i class="fa fa-print text-white mr-2"></i>
              <span class="text-white">(51) 260203</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Legacy content for specific groups -->
      <div class="row mt-4" v-if="$store.state.app.activeGroup.id == 9358">
        <div class="col-md-12 text-center">
          <div v-if="homeSettingFooterName !== '' || homeSettingFooterMobile !== '' || homeSettingFooterEmail !== ''" class="text-white" 
          style="font-weight: 600; border-bottom: 1px solid #FFFFFF; padding-bottom: 10px; max-width: 300px; margin: 0 auto;">
            Холбогдох ажилтны мэдээлэл
          </div>
          <div class="d-flex justify-content-center mg-t-5">
            <div class="nav-item" v-if="homeSettingFooterName !== ''">
              <a class="nav-link text-white">Нэр : {{homeSettingFooterName}}</a>
            </div>
            <div class="nav-item" v-if="homeSettingFooterMobile !== ''">
              <a :href="`tel:${homeSettingFooterMobile}`" class="nav-link text-white">Утас : {{ homeSettingFooterMobile }}</a>
            </div>
            <div class="nav-item" v-if="homeSettingFooterEmail !== ''">
              <a :href="`mailto:${homeSettingFooterEmail}`" class="nav-link text-white">И-мэйл : {{ homeSettingFooterEmail }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="copyright">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <span>
              © <span>{{ $store.state.app.activeGroup.name | stripHtml }}</span
              >, бүх эрх хуулиар хамгаалагдсан.
            </span>
            <a href="https://www.gosmart.mn" class="text-white" target="_blank">
              <img :src="`${myResBaseUrl}/media/favicon/fav.png`" />
              Хөгжүүлсэн ГөүCмарт ТМ ХХК</a
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { request } from "@/api/all";
var _ = require("lodash");

export default {
  data(){
    return{
      myResBaseUrl: "https://res.gosmart.mn/",
      homeSettingFooterName: "",
      homeSettingFooterMobile: "",
      homeSettingFooterEmail: "",
      pages: [],
    }
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }

    request({
      api: { method: "GET", url: "User/GetHomeSettingsByKey" },
      params: { key: this.$store.state.app.activeGroup.key },
      store: this.$store,
    }).then((res) => {
      if (res != false) {
        let tempFooterName = res.settings.filter((x) => x.key == "homeSetting_FooterName");
        let tempFooterMobile = res.settings.filter((x) => x.key == "homeSetting_FooterMobile");
        let tempFooterEmail = res.settings.filter((x) => x.key == "homeSetting_FooterMail");
        
        if (tempFooterName.length > 0 && tempFooterName[0].value !== "") {
          this.homeSettingFooterName = tempFooterName[0].value;
        }
        if (tempFooterMobile.length > 0 && tempFooterMobile[0].value !== "") {
          this.homeSettingFooterMobile = tempFooterMobile[0].value;
        }
        if (tempFooterEmail.length > 0 && tempFooterEmail[0].value !== "") {
          this.homeSettingFooterEmail = tempFooterEmail[0].value;
        }
      }
    });
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // console.log('this.$store.state.app.pages', this.$store.state.app.pages);
      this.pages = _.sortBy(this.$store.state.app.pages.filter( x => x.i2 == 1 && x.i1 == 0 && x.parentId == 0 ), "ord", "asc");
      // console.log('this.pages', this.pages);
    }
  }
};
</script>

<style lang="scss">
.golomt-footer{
  background: linear-gradient(174deg,#114e92,#011d45) !important;
  .container{
    max-width: 1200px !important;
  }
}
.footer-links .nav-link:hover {
  color: #ddd !important;
  text-decoration: none;
}

.contact-info .contact-item {
  display: flex;
  align-items: flex-start;
}

.contact-info .contact-item i {
  margin-top: 2px;
  min-width: 16px;
}

.footer-links .dropdown-item {
  cursor: pointer;
  padding: 2px 0;
}

.footer-links .dropdown-item:hover {
  color: #ddd !important;
}
</style>
